var _rect, _rect2, _rect3, _rect4, _text, _text2, _text3, _rect5, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _ellipse, _ellipse2, _ellipse3, _ellipse4, _text14, _text15, _text16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeoPlot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: 251.071,
    viewBox: "0 0 328.227 251.071",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_3111",
    "data-name": "Group 3111",
    transform: "translate(-1899.438 -2228.44)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 184.523,
    height: 77.215,
    transform: "translate(1947.413 2309.064)",
    fill: "#fcf1ef"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 29.295,
    height: 18.072,
    transform: "translate(1938.423 2441.885)",
    fill: "#f6d6d1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 29.295,
    height: 18.072,
    transform: "translate(2050.563 2441.885)",
    fill: "#fcf1ef"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 29.295,
    height: 18.072,
    transform: "translate(2162.203 2441.885)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25,
    opacity: 0.999
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Top_Competitor",
    "data-name": "Top Competitor",
    transform: "translate(2022.557 2238.44)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Top Competitor"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "Your_Practice",
    "data-name": "Your Practice",
    transform: "translate(1914.872 2238.44)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Your Practice"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    id: "Top_30",
    "data-name": "Top 30",
    transform: "translate(2144.279 2238.44)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Top 30"))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1484",
    "data-name": "Rectangle 1484",
    width: 91.406,
    height: 38.215,
    transform: "translate(1948.414 2348.064)",
    fill: "#f6d6d1"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    id: "_20",
    "data-name": 20,
    transform: "translate(1937.411 2352.281)",
    fill: "#7f7f7f",
    fontSize: 8,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.984,
    y: 0
  }, "20"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    id: "_10",
    "data-name": 10,
    transform: "translate(1937.411 2309.782)",
    fill: "#7f7f7f",
    fontSize: 8,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.984,
    y: 0
  }, "10"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    id: "_1",
    "data-name": 1,
    transform: "translate(1935.413 2272.703)",
    fill: "#7f7f7f",
    fontSize: 9,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.054,
    y: 0
  }, "1"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    id: "_30",
    "data-name": 30,
    transform: "translate(1937.411 2384.37)",
    fill: "#7f7f7f",
    fontSize: 8,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.984,
    y: 0
  }, "30"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    id: "_10-2",
    "data-name": 10,
    transform: "translate(2131.659 2406.979)",
    fill: "#7f7f7f",
    fontSize: 9,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.054,
    y: 0
  }, "10"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    id: "_20-2",
    "data-name": 20,
    transform: "translate(2038.542 2405.884)",
    fill: "#7f7f7f",
    fontSize: 9,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.054,
    y: 0
  }, "20"))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    id: "_30-2",
    "data-name": 30,
    transform: "translate(1950.432 2406.979)",
    fill: "#7f7f7f",
    fontSize: 9,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.054,
    y: 0
  }, "30"))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    id: "Overall_Rank",
    "data-name": "Overall Rank",
    transform: "translate(2080.115 2424.603)",
    fill: "#7f7f7f",
    fontSize: 9,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -24.82,
    y: 0
  }, "Overall Rank"))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    id: "Avg._Keyword_Rank",
    "data-name": "Avg. Keyword Rank",
    transform: "translate(1912.808 2336.564) rotate(-90)",
    fill: "#7f7f7f",
    fontSize: 9,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -38.268,
    y: 0
  }, "Avg. Keyword Rank"))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    id: "_1-2",
    "data-name": 1,
    transform: "translate(2221.776 2405.979)",
    fill: "#7f7f7f",
    fontSize: 8,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -2.246,
    y: 0
  }, "1"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_131",
    "data-name": "Line 131",
    y1: 123.047,
    transform: "translate(1947.935 2272.5)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_135",
    "data-name": "Line 135",
    y1: 123.531,
    transform: "translate(2040.05 2272.016)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_138",
    "data-name": "Line 138",
    y1: 123.531,
    transform: "translate(2132.166 2272.016)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "Line_139",
    "data-name": "Line 139",
    y1: 123.531,
    transform: "translate(2223.28 2272.016)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "Line_134",
    "data-name": "Line 134",
    x2: 285.203,
    transform: "translate(1938.578 2348.5)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "Line_132",
    "data-name": "Line 132",
    x2: 285.203,
    transform: "translate(1938.578 2310.5)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    id: "Line_130",
    "data-name": "Line 130",
    x2: 285.203,
    transform: "translate(1938.578 2272.5)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    id: "Line_136",
    "data-name": "Line 136",
    x2: 285.203,
    transform: "translate(1938.578 2386.5)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1767",
    "data-name": "Group 1767",
    transform: "translate(1943.398 2267.876)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    cx: 4.564,
    cy: 4.558,
    rx: 4.564,
    ry: 4.558,
    transform: "translate(275.139)",
    fill: "#74ad85"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    cx: 4.564,
    cy: 4.558,
    rx: 4.564,
    ry: 4.558,
    transform: "translate(268.046 4.251)",
    fill: "#e6e7e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_65",
    "data-name": "Ellipse 65",
    cx: 4.564,
    cy: 4.558,
    rx: 4.564,
    ry: 4.558,
    transform: "translate(261.662 5.667)",
    fill: "#e6e7e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_66",
    "data-name": "Ellipse 66",
    cx: 4.564,
    cy: 4.558,
    rx: 4.564,
    ry: 4.558,
    transform: "translate(251.022 9.21)",
    fill: "#e27867",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_67",
    "data-name": "Ellipse 67",
    cx: 4.564,
    cy: 4.558,
    rx: 4.564,
    ry: 4.558,
    transform: "translate(224.273 20.583)",
    fill: "#e6e7e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_68",
    "data-name": "Ellipse 68",
    cx: 4.564,
    cy: 4.558,
    rx: 4.564,
    ry: 4.558,
    transform: "translate(212.712 20.926)",
    fill: "#e6e7e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_69",
    "data-name": "Ellipse 69",
    cx: 4.564,
    cy: 4.558,
    rx: 4.564,
    ry: 4.558,
    transform: "translate(173.407 52.661)",
    fill: "#e6e7e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_70",
    "data-name": "Ellipse 70",
    cx: 4.564,
    cy: 4.558,
    rx: 4.564,
    ry: 4.558,
    transform: "translate(159.534 56.931)",
    fill: "#e6e7e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_71",
    "data-name": "Ellipse 71",
    cx: 4.564,
    cy: 4.558,
    rx: 4.564,
    ry: 4.558,
    transform: "translate(150.286 60.489)",
    fill: "#e6e7e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_72",
    "data-name": "Ellipse 72",
    cx: 4.564,
    cy: 4.558,
    rx: 4.564,
    ry: 4.558,
    transform: "translate(142.193 61.912)",
    fill: "#e6e7e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_73",
    "data-name": "Ellipse 73",
    cx: 4.564,
    cy: 4.558,
    rx: 4.564,
    ry: 4.558,
    transform: "translate(126.009 66.894)",
    fill: "#e6e7e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_74",
    "data-name": "Ellipse 74",
    cx: 4.564,
    cy: 4.558,
    rx: 4.564,
    ry: 4.558,
    transform: "translate(112.136 78.992)",
    fill: "#e6e7e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_75",
    "data-name": "Ellipse 75",
    cx: 4.564,
    cy: 4.558,
    rx: 4.564,
    ry: 4.558,
    transform: "translate(99.42 84.685)",
    fill: "#e6e7e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    cx: 4.564,
    cy: 4.558,
    rx: 4.564,
    ry: 4.558,
    transform: "translate(92.483 84.685)",
    fill: "#e6e7e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_77",
    "data-name": "Ellipse 77",
    cx: 4.564,
    cy: 4.558,
    rx: 4.564,
    ry: 4.558,
    transform: "translate(84.391 88.954)",
    fill: "#e6e7e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_78",
    "data-name": "Ellipse 78",
    cx: 4.564,
    cy: 4.558,
    rx: 4.564,
    ry: 4.558,
    transform: "translate(64.738 89.513)",
    fill: "#e6e7e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_79",
    "data-name": "Ellipse 79",
    cx: 4.564,
    cy: 4.558,
    rx: 4.564,
    ry: 4.558,
    transform: "translate(53.178 90.695)",
    fill: "#e6e7e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_80",
    "data-name": "Ellipse 80",
    cx: 4.564,
    cy: 4.558,
    rx: 4.564,
    ry: 4.558,
    transform: "translate(26.245 97.567)",
    fill: "#e6e7e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_81",
    "data-name": "Ellipse 81",
    cx: 4.564,
    cy: 4.558,
    rx: 4.564,
    ry: 4.558,
    transform: "translate(17.733 100.398)",
    fill: "#e6e7e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_82",
    "data-name": "Ellipse 82",
    cx: 4.564,
    cy: 4.558,
    rx: 4.564,
    ry: 4.558,
    transform: "translate(8.512 106.774)",
    fill: "#e6e7e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_83",
    "data-name": "Ellipse 83",
    cx: 4.564,
    cy: 4.558,
    rx: 4.564,
    ry: 4.558,
    transform: "translate(0 113.15)",
    fill: "#e6e7e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_84",
    "data-name": "Ellipse 84",
    cx: 4.564,
    cy: 4.558,
    rx: 4.564,
    ry: 4.558,
    transform: "translate(204.62 29.177)",
    fill: "#e6e7e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_85",
    "data-name": "Ellipse 85",
    cx: 4.564,
    cy: 4.558,
    rx: 4.564,
    ry: 4.558,
    transform: "translate(196.528 32.024)",
    fill: "#e6e7e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    cx: 4.564,
    cy: 4.558,
    rx: 4.564,
    ry: 4.558,
    transform: "translate(182.738 40.87)",
    fill: "#e6e7e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_341",
    "data-name": "Ellipse 341",
    cx: 4.694,
    cy: 4.688,
    rx: 4.694,
    ry: 4.688,
    transform: "translate(1899.438 2232.763)",
    fill: "#e27867"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_342",
    "data-name": "Ellipse 342",
    cx: 4.694,
    cy: 4.688,
    rx: 4.694,
    ry: 4.688,
    transform: "translate(2007.573 2232.763)",
    fill: "#74ad85"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_343",
    "data-name": "Ellipse 343",
    cx: 4.694,
    cy: 4.688,
    rx: 4.694,
    ry: 4.688,
    transform: "translate(2130.728 2232.763)",
    fill: "#e6e7e8"
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    id: "Ideal",
    transform: "translate(2173.658 2477.511)",
    fill: "#7f7f7f",
    fontSize: 9,
    fontFamily: "Roboto-Black, Roboto",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.289,
    y: 0
  }, "IDEAL"))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    id: "Average",
    transform: "translate(2062.512 2476.511)",
    fill: "#7f7f7f",
    fontSize: 8,
    fontFamily: "Roboto-Black, Roboto",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -17.754,
    y: 0
  }, "AVERAGE"))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    id: "Poor",
    transform: "translate(1951.381 2476.511)",
    fill: "#7f7f7f",
    fontSize: 8,
    fontFamily: "Roboto-Black, Roboto",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -10.736,
    y: 0
  }, "POOR")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeoPlot);
export default __webpack_public_path__ + "static/media/seoPlot.51ff0746.svg";
export { ForwardRef as ReactComponent };